module.exports = __webpack_public_path__ + "static/ibm-plex-sans-v7-latin-regular-a2c56f946488a9a267ba6ba21471a217.woff";